export const FETCH_CALL_STATUS = "FETCH_CALL_STATUS";
export const FETCH_CALL_STATUS_SUCCESS = "FETCH_CALL_STATUS_SUCCESS";

export const fetchCallStatusData = (payload) => ({
  type: FETCH_CALL_STATUS,
  payload,
});
export const fetchCallStatusDataSuccess = (payload) => ({
  type: FETCH_CALL_STATUS_SUCCESS,
  payload,
});
